var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.7143,
    height: 25.7143,
    rx: 3.85714,
    fill: "#808080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.321429,
    y: 0.321429,
    width: 25.0714,
    height: 25.0714,
    rx: 3.53571,
    fill: "#808080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.321429,
    y: 0.321429,
    width: 25.0714,
    height: 25.0714,
    rx: 3.53571,
    stroke: "#808080",
    strokeWidth: 0.642857
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 12.8571C7.07031 12.4835 7.07031 12.2967 7.10728 12.1434C7.20759 11.7274 7.5 11.4025 7.87436 11.2911C8.01232 11.25 8.18046 11.25 8.51674 11.25H17.1953C17.5316 11.25 17.6998 11.25 17.8377 11.2911C18.2121 11.4025 18.5045 11.7274 18.6048 12.1434C18.6417 12.2967 18.6417 12.4835 18.6417 12.8571C18.6417 13.2308 18.6417 13.4176 18.6048 13.5709C18.5045 13.9868 18.2121 14.3117 17.8377 14.4232C17.6998 14.4643 17.5316 14.4643 17.1953 14.4643H8.51674C8.18046 14.4643 8.01232 14.4643 7.87436 14.4232C7.5 14.3117 7.20759 13.9868 7.10728 13.5709C7.07031 13.4176 7.07031 13.2308 7.07031 12.8571Z",
    stroke: "white",
    strokeWidth: 0.964286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove2);
export default __webpack_public_path__ + "static/media/remove2.9a2ed6278b5f39e2095a70491d4826e6.svg";
export { ForwardRef as ReactComponent };